import { gql } from "@apollo/client";

const SALESDONECOUNTCHANGED = gql`
  subscription salesdonecountchanged {
    salesdonecountchanged {
      success
      error
      result
    }
  }
`;
export default SALESDONECOUNTCHANGED;
